import { call, put, takeLatest } from 'redux-saga/effects';

import * as walletActions from './walletActions.js';
import { updateWalletApiCall } from './walletAPI.js';

function* updateWalletSaga({ payload }) {
  try {
    const { data } = yield call(updateWalletApiCall, payload);
    yield put(walletActions.walletUpdateStore(data));
  } catch (error) {
    yield put(walletActions.walletUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* walletWatcher() {
  yield takeLatest(walletActions.walletUpdateRequest.type, updateWalletSaga);
}
